<template>
  <vs-chip class="ag-grid-cell-chip">
    <span>{{
      params.value != null
        ? this.SetTimeByZone(params.value, Session_Event_TZ)
        : ""
    }}</span>
  </vs-chip>
</template>

<script>
import moment from "moment-timezone";
import ls from "@/common/localStorage";
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
export default {
  name: "CellRendererCreatedOnReg",
  computed: {
    chipColor() {
      return (value) => {
        // if (value === "completed") return "success";
        // else if (value === "pending") return "warning";
        // else if (value === null) return "warning";
        // else return "primary";
      };
    },
  },
  methods: {
    SetTimeByZone: function (strDateTime, timeZone) {
      var date;
      if (strDateTime.seconds) {
        date = moment
          .tz(strDateTime.seconds * 1000, Session_Event_TZ)
          .format("MMM DD, YYYY hh:mm A");
      } else {
        date = moment
          .tz(strDateTime, Session_Event_TZ)
          .format("MMM DD, YYYY hh:mm A");
      }

      return date;
    },
  },
};
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success), 0.15);
    color: rgba(var(--vs-success), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning), 0.15);
    color: rgba(var(--vs-warning), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 0.15);
    color: rgba(var(--vs-danger), 1) !important;
    font-weight: 500;
  }
}
</style>
